import { useEffect } from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';

import { usePatch } from 'hooks';
import { manageMembers } from 'services/api';
import {
  getAddToTarget,
  getActiveList,
  getSelectedMemberIds,
  getSelectedMembers,
  getView,
} from 'selectors/lists';

import { NotificationSuccess, NotificationFailure } from '../Notifications';

const AddTo = ({ onClose }) => {
  const view = useSelector(getView);
  const targetList = useSelector(getAddToTarget);
  const activeList = useSelector(getActiveList);
  const selectedMembers = useSelector(getSelectedMembers);
  const selectedMemberIds = useSelector(getSelectedMemberIds);

  const [{ res: addRes, loading, error }, patchMembers] = usePatch({
    url: manageMembers(targetList.id, view),
  });

  useEffect(() => {
    if (addRes) {
      onClose();
      NotificationSuccess(null, view);
    }

    if (error && error.status === 400) {
      onClose();
      NotificationFailure(error.message, view);
    }
  }, [addRes, error, onClose, view]);

  const handleAdd = () => {
    patchMembers({
      addFromListId: activeList.id,
      researcherIds: selectedMemberIds,
      memberIds: selectedMemberIds,
      excludedFromAllResearcherIds: Object.keys(selectedMembers.exclude),
      excludedFromAllMemberIds: Object.keys(selectedMembers.exclude).map(
        x => +x
      ),
    });
  };

  return (
    <Modal
      open
      title={`Add Members to ${targetList.name}`}
      onCancel={onClose}
      okText='Yes'
      onOk={handleAdd}
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      Would you like to add the selected members of {activeList.name} to{' '}
      {targetList.name}?
    </Modal>
  );
};

export default AddTo;
